import React from "react";
import getMuiTheme  from "material-ui/styles/getMuiTheme";

export default class ClassWrapper extends React.PureComponent  {
    static get propTypes() {
        return {
            namespace: React.PropTypes.string.isRequired,
            children: React.PropTypes.element.isRequired,
            theme: React.PropTypes.object.isRequired,
        };
    }

    getChildContext() {
        return {
            muiTheme : getMuiTheme(this.props.theme)
        };
    }

    static get childContextTypes() {
        return {
            muiTheme: React.PropTypes.object.isRequired,
        };
    }

    render() {
        return (
            <div className={this.props.namespace}>
                {this.props.children}
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/ClassWrapper.js
 **/